import { gql } from "utils/urql";
import styles from "./ArticleFoundationLine.module.scss";
import { ArticleFoundationLineSwanFragment } from "types/api";

const ArticleFoundationLine = ({
  foundationLineArticle,
}: ArticleFoundationLineSwanFragment) => {
  if (!foundationLineArticle) return null;
  return (
    <section className={styles.root}>
      <p
        className={styles.content}
        dangerouslySetInnerHTML={{ __html: foundationLineArticle }}
      />
    </section>
  );
};

export default ArticleFoundationLine;

ArticleFoundationLine.fragment = gql`
  fragment articleFoundationLineSwan on EditorialProject {
    foundationLineArticle
  }
`;
